import {postMethod, putMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/prepareActivityBook', request)
}

async function put(basketKey, request) {
    return await putMethod(`/api/prepareActivityBook/${basketKey}`, request)
}

export {post, put}
